/**************************************************
 * Nombre:       Formulario_Anuncios
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {TitleOutlined, Flag, PhoneAndroidOutlined, TextFormatOutlined,ShortTextOutlined} from "@mui/icons-material";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import {ESTADOSMAYORISTAS, ESTADOSPRODUCTO} from "../../Constantes";
import IngresoImagenCrop from "../../Modulo_formularios/Componentes/IngresoImagenCrop";

const Formulario_Anuncios = ({...props}) => {

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <IngresoImagenCrop dato={'img'} alto={21} ancho={15} {...props}  />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography sx={{fontSize: 14}}>**Imagen de 1500px por 2100px de menos de 500K de peso</Typography>
                </Grid>

                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoSelect Icono={Flag} nombre={'Estado'} dato={'estado'} {...props}
                                   requerido={'El estado es requerido'}
                                   opciones={ESTADOSPRODUCTO.map((it) => it.nombre)}
                    />
                </Grid>


                <Grid container size={12}>
                    <IngresoTexto Icono={ShortTextOutlined} nombre={'Texto Naranja'}
                                  dato={'subTituloUno'} {...props}

                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={TitleOutlined} nombre={'Titulo del Anuncio'}
                                  dato={'nombre'} {...props}
                                  requerido={'Campo requerido'}
                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={TextFormatOutlined} nombre={'Texto pequeño verde'}
                                  dato={'subTituloDos'} {...props}

                    />

                </Grid>

                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoTexto Icono={PhoneAndroidOutlined} nombre={'Texto Bonton'} dato={'textoBoton'} {...props}

                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={PhoneAndroidOutlined} nombre={'Link Bonton'} dato={'link'} {...props}

                    />
                </Grid>




            </Grid>

        </form>

    )

}
export default Formulario_Anuncios